










































































import { Component, Vue } from "vue-property-decorator";
import { IConference } from "@/models/Conference.model";
import FileUpload from "@/components/shared/FileUpload.vue";
@Component({ components: { FileUpload } })
export default class ConferenceForm extends Vue {
  conference: IConference = {};
  newConference: IConference = {};

  get currentConference() {
    return this.$store.getters.getConference;
  }

  update() {
    this.$emit("insertConference", this.conference);
  }

  editConference() {
    console.log(this.newConference);
    this.$emit("editConference", this.newConference);
  }

  deleteConference() {
    this.$emit("deleteConference");
  }

  uploaded(link: string) {
    this.conference.link = link;
  }
  newImage(link: string) {
    this.newConference.link = link;
  }

  mounted() {
    this.newConference = Object.assign({}, this.currentConference);
    console.log(this.newConference);
  }
}
